<template id="countdown-template">
  <div class="countdown-div">
    <div class="countdown-title">
      <p>Renewal Deadline: </p>
    </div>
    <div class="countdown">
      <div class="block">
        <p class="countdown-digit">{{ days }}</p>
        <p class="countdown-text">Days : </p>
      </div>
      <div class="block">
        <p class="countdown-digit">{{ hours }}</p>
        <p class="countdown-text">Hours : </p>
      </div>
      <div class="block">
        <p class="countdown-digit">{{ minutes }}</p>
        <p class="countdown-text">Minutes : </p>
      </div>
      <div class="block">
        <p class="countdown-digit">{{ seconds }}</p>
        <p class="countdown-text">Seconds</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapState,
} from 'vuex'

export default {
  mounted() {
    window.setInterval(() => {
        this.now = Math.trunc((new Date()).getTime() / 1000);
    },1000);
  },
  props: {
    date: {
      type: String
    }
  },
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000)
    }
  },
  computed: {
    dateInMilliseconds() {
      return Math.trunc(Date.parse(this.date) / 1000)
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
    },
    hours() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
    },
    days() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
    },
  }
}

  
</script>

<style>
  .countdown {
    display: flex;
    justify-content: center;
  }

  .block {
    display: flex;
    margin: 0px;
    flex-direction: row;
  }

  .countdown-div {
    display:flex;
    flex-direction:row;
    justify-content: center;
  }

  .countdown-title {
    display:flex;
    justify-content: center
  }

  .countdown-title>p {
      color: #ffffff;
      font-size: 1em;
      font-family: 'Roboto', serif;
      text-align: center;
      margin-top:0px;
      margin-bottom:0px;
  }
  
  .countdown-text {
      color: #ffffff;
      font-size: 0.9em;
      font-family: 'Roboto', serif;
      text-align: center;
      margin-left: 5px;
      margin-top:0px;
      margin-bottom:0px;
  }

  .countdown-digit {
      color: #ffffff;
      font-size: 0.9em;
      font-family: 'Roboto', serif;
      margin-left: 5px;
      text-align: center;
      margin-top:0px;
      margin-bottom:0px;
  }

  @media (max-width: 992px) {
    .countdown-text,
    .countdown-digit,
    .countdown-title > p {
      font-size:0.8em;
    }
  }

  @media (max-width: 590px) {
    .countdown-text,
    .countdown-digit,
    .countdown-title > p {
      font-size:0.6em;
    }
    .countdown-div {
      width:230px;
    }

    .countdown-title {
      display:none;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/CountdownContainer.vue